import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';

@Component({
  selector: 'app-form-contacto',
  templateUrl: './form-contacto.component.html',
  styleUrls: ['./form-contacto.component.scss'],
})
export class FormContactoComponent implements OnInit {
  public fGroup: FormGroup;
  constructor(private conexion: ConexionService, private fb: FormBuilder, private utilidades: UtilidadesService) {
    this.fGroup = fb.group({
      Nombre: ["", [Validators.required]],
      Email: ["", [Validators.required, Validators.email]],
      Mensaje: ["", [Validators.required]]
    })
   }

  ngOnInit() {}

  CorreoContacto(){
    this.utilidades.Loading("Enviando mensaje")
    if(this.fGroup.valid){
      this.conexion.CorreoContacto(this.fGroup.value).subscribe((resp:any)=>{
        this.utilidades.Toast(resp.Mensaje)
        this.utilidades.CerrarLoading()
        this.fGroup.reset()
      }, (err)=>{
        this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)
        this.fGroup.reset()
      }, ()=>{
        this.fGroup.reset()
        this.utilidades.CerrarLoading()
      })
    }else{
      this.utilidades.Alerta("Completa todos los campos antes de continuar")
      this.utilidades.CerrarLoading()
    }
  }

}
